angular.module('kareo.ui.shared.directives.choose-document.reference-services', [])
  .service('AttachmentDocumentService', ['$http', function ($http) {
    function documentListURL(pageNum, searchInput) {
      if (!pageNum) {
        pageNum = 1; // pageNumber is 1 indexed
      }
      var url = '/common-ui/api/Attachment/DocumentList?pageNumber=' + pageNum;
      if (searchInput) {
        url += '&searchInput=' + searchInput;
      }
      return url;
    }

    var documentURL = '/common-ui/api/Attachment/Document';

    function buildDocumentURL(documentName, fileName, comment, utcDate, documentStatus, documentLabel, mimeType, isKmbDocument) {
      return documentURL + '?documentName=' + documentName + '&fileName=' + fileName +
          '&comment=' + comment + '&utcDate=' + utcDate + '&documentStatus=' + documentStatus +
          '&documentLabel=' + documentLabel + '&mimeType=' + mimeType +
          (isKmbDocument ? '&isKmbDocument=' + isKmbDocument : '');
    }

    return {
      getDocuments(pageNum, searchInput) {
        return $http.get(documentListURL(pageNum, searchInput)).then((response) => {
          return response.data;
        });
      },
      uploadFile(file, documentName, filename, comment, utcDate, documentStatus, documentLabel, callBack, isKmbDocument) {
          // Upload mechanism safe for embedding in PM
          // We should just be able to use flow's upload mechanism, but our CefSharp implementation is sensitive to XHR requests
        var formdata,
xhr;
        formdata = new FormData();
        formdata.append('file', file, filename);
        xhr = new XMLHttpRequest();
        xhr.open('post', buildDocumentURL(documentName, filename, comment, utcDate, documentStatus, documentLabel, file.type, isKmbDocument), true);
        xhr.onload = function () {
          callBack(JSON.parse(xhr.responseText));
        };
        xhr.send(formdata);
      },
      getDocumentLabels() {
        return $http.get(documentURL + '/labels').then((response) => {
          return response.data;
        });
      },
        /**
         * You can pass in references (primarily used in messages) to detect duplicates and raise validation errors
         *
         * Usage: AttachmentDocumentService.findDuplicate(references, refs) before selecting the document
         * @param references
         * @param ref
         */
      findDuplicate(references, ref) {
        var searchArray = references || [];
        for (var index = 0; index < searchArray.length; index++) {
          if ((ref.documentId && searchArray[index].entityReferenceIntId === ref.documentId) || ((ref.guid || ref.entityReferenceGuidId) && searchArray[index].entityReferenceGuidId === (ref.entityReferenceGuidId || ref.guid))) {
            return index;
          }
        }
        return -1;
      }
    };
  }]);
